module.exports = __webpack_public_path__ + "img/12.e62628bb.png";